"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx withSlots */
var React = require("react");
var Foundation_1 = require("../../../Foundation");
var StackItem_styles_1 = require("./StackItem.styles");
var view = function (props) {
    var children = props.children;
    if (React.Children.count(children) < 1) {
        return null;
    }
    var Slots = Foundation_1.getSlots(props, {
        root: 'div'
    });
    return Foundation_1.withSlots(Slots.root, null, children);
};
exports.StackItem = Foundation_1.createComponent({
    displayName: 'StackItem',
    styles: StackItem_styles_1.StackItemStyles,
    view: view
});
exports.default = exports.StackItem;
//# sourceMappingURL=StackItem.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Stack/StackItem/StackItem.js
// module id = 1195
// module chunks = 0